import * as types from "../Types/MobilyticsActionTypes";
import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { ISubmitMobilyticsJobRequest } from "../../../Models/Requests/ISubmitMobilyticsJobRequest";
import { PolygonType } from "../Models/Maps/Enums/PolygonType";
import { IPolygon } from "../Models/Maps/IPolygon";
import { IMobilyticsScenarioFormState } from "../Pages/Apps/Mobilytics/SubmitMobilyticsLogic";
import { ISafegraphLocation } from "../../../Models/ISafegraphLocation";

export const setCustomReportTitle = (customTitle: string): types.SetCustomReportTitle => ({
    type: types.SET_CUSTOM_REPORT_TITLE,
    data: customTitle
});

export const setIsLoading = (
    loading: boolean
): types.SetLoadingMobilyticsReportAction => ({
    type: types.SET_LOADING_MOBILYTICS_REPORT,
    data: loading,
});

export const setSearchedMobilyticsPlace = (
    placeId: string,
    name: string,
): types.SetSearchedPlaceMobilyticsAction => ({
    type: types.SET_SEARCHED_PLACE_MOBILYTICS_ACTION,
    data: {
        name,
        placeId,
        lat: -1,
        lng: -1,
        address: null,
        points: [],
    },
});

export const setMostRecentlySubmittedMobilyticsReport = (
    report: IGCPBigQueryJob[],
): types.SetMostRecentlySubmittedMobilyticsReportAction => ({
    type: types.SET_MOST_RECENTLY_SUBMITTED_MOBILYTICS_REPORT,
    data: report
});

export const removeSearchedMobilyticsPlace = (): types.RemoveSearchedPlaceMoblyitcsAction => ({
    type: types.REMOVE_SEARCHED_PLACE_MOBILYTICS_ACTION
});

export const removePolygon = (id: string): types.RemovePolygonAction => ({
    type: types.REMOVE_POLYGON_ACTION,
    data: id
});

export const submitMobilyticsReportInitiate = (
    request: ISubmitMobilyticsJobRequest
): types.SubmitMobilyticsReportInitiateAction => ({
    type: types.SUBMIT_MOBILYTICS_REPORT_INITIATE,
    data: request,
});

export const submitMobilyticsReportSuccess = (report: IGCPBigQueryJob[]): types.SubmitMobilyticsReportSuccessAction => ({
    type: types.SUBMIT_MOBILYTICS_REPORT_SUCCESS,
    data: report,
});

export const submitMobilyticsReportFailure = (
    message: string
): types.SubmitMobilyticsReportFailureAction => ({
    type: types.SUBMIT_MOBILYTICS_REPORT_FAILURE,
    data: message,
});

export const setIsCreatingCustomLocation = (
    isCreating: boolean
): types.SetIsCreatingCustomLocationAction => ({
    type: types.SET_IS_CREATING_CUSTOM_LOCATION_ACTION,
    data: isCreating
});

export const setIsViewingLocationDetails = (
    isViewing: boolean
): types.SetIsViewingLocationDetailsAction => ({
    type: types.SET_IS_VIEWING_LOCATION_DETAILS,
    data: isViewing
});

export const setIsRedirectedFromCreateCustomLocation = (
    isRedirected: boolean
): types.SetIsCreatingCustomLocationAction => ({
    type: types.SET_IS_REDIRECTED_FROM_CREATE_CUSTOM_LOCATION,
    data: isRedirected
});

export const setCreateCustomLocationParameters = (
    data: types.CreateCustomLocationParameters
): types.SetCreateCustomLocationParametersAction => ({
    type: types.SET_CREATE_CUSTOM_LOCATION_PARAMETERS_ACTION,
    data
});

export const setLocationDetails = (
    data: types.LocationDetailsParameters
): types.SetLocationDetailsAction => ({
    type: types.SET_LOCATION_DETAILS_ACTION,
    data
});

export const onCustomLocationSelected = (
    data: types.PlaceParameters
): types.OnCustomLocationSelectedAction => ({
    type: types.ON_CUSTOM_LOCATION_SELECTED_ACTION,
    data
});

export const onLocationSelectedForAnalysis = (
    data: types.PlaceParameters
): types.OnCustomLocationSelectedAction => ({
    type: types.ON_LOCATION_SELECTED_FOR_ANALYSIS_ACTION,
    data
});

export const setIsDrawingPolygon = (isDrawingPolygon: boolean): types.SetIsDrawingPolygonAction => ({
    type: types.SET_IS_DRAWING_POLYGON,
    data: isDrawingPolygon,
});

export const setDrawPolygonType = (polygonType: PolygonType): types.SetDrawPolygonAction => ({
    type: types.SET_DRAW_POLYGON_TYPE,
    data: polygonType,
});

export const setSavedPolygons = (polygons: IPolygon[]): types.SetSavedPolygonsAction => ({
    type: types.SET_SAVED_POLYGONS,
    data: polygons,
});

export const setInProcessPolygon = (polygon: IPolygon): types.SetInProcessPolygonAction => ({
    type: types.SET_IN_PROCESS_POLYGON,
    data: polygon,
});

export const setScenarioFormStates = (scenarios: IMobilyticsScenarioFormState[]): types.SetMobilyticsScenariosAction => ({
    type: types.SET_MOBILYTICS_SCENARIOS,
    data: scenarios,
});

export const setShouldShowEndOfReportScreen = (shouldShowEndOfReport: boolean): types.SetShouldShowEndOfReportScreenAction => ({
    type: types.SET_SHOULD_SHOW_END_OF_REPORT_SCREEN_ACTION,
    data: shouldShowEndOfReport,
});

export const getNearbyLocations = (): types.GetNearbyLocationsAction => ({
    type: types.GET_NEARBY_LOCATIONS_ACTION
});

export const getSimilarLocations = (): types.GetSimilarLocationsAction => ({
    type: types.GET_SIMILAR_LOCATIONS_ACTION
});

export const setNearbyLocations = (locations: ISafegraphLocation[]): types.SetNearbyLocationsAction => ({
    type: types.SET_NEARBY_LOCATIONS_ACTION,
    data: locations,
});

export const setSimilarLocations = (locations: ISafegraphLocation[]): types.SetSimilarLocationsAction => ({
    type: types.SET_SIMILAR_LOCATIONS_ACTION,
    data: locations,
});

export const setSelectedSafegraphLocation = (location: ISafegraphLocation): types.SetSelectedSafegraphLocationAction => ({
    type: types.SET_SELECTED_SAFEGRAPH_LOCATION_ACTION,
    data: location,
});

export const setIsSearchingForNewLocation = (isSearchingForNewLocation: boolean): types.SetIsSearchingForNewLocationAction => ({
    type: types.SET_IS_SEARCHING_FOR_NEW_LOCATION_ACTION,
    data: isSearchingForNewLocation,
});

export const startMobilyticsFromSameMatchLocation = (formState: IMobilyticsScenarioFormState): types.StartMobilyticsFromSameMatchLocation => ({
    type: types.START_MOBILYTICS_FROM_SAME_MATCH_LOCATION,
    data: formState,
});

export const setIsLoadingLocations = (isLoading: boolean): types.SetIsLoadingLocationsAction => ({
    type: types.SET_IS_LOADING_LOCATIONS,
    data: isLoading
});